module.exports = __webpack_public_path__ + "static/media/Kone-Logo.3a8d3f45.svg";